import ResetPassword from "./ResetPassword";
import PasswordReset from "./ResetAuth";
import "./styles.scss";

export default {
  ResetPassword,
  PasswordReset,
};
